import React, { useEffect } from 'react';
import { connect } from "react-redux";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ConsumerPromotionMiddleware from '../../../store/middleware/consumerPromotionMiddleware';
import { Loader } from "../../../components/loader";
import './ConsumerPromotionHistory.styles.scss';

const ConsumerPromotionHistory = (props) => {

    useEffect(() => {
        props.getConsumerPromotionHistory(
            props.selectedCategory,
            props.selectedBrand,
            props.selectedMasterSku
        );
    },
        //eslint-disable-next-line 
        [])

    const handleClose = () => {
        props.flagHandle()
    };

    return (
        <div>
            < Modal
                className='modal'
                open={props.isOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={props.isOpen} >

                    <div className='cp-history-container'>
                        <div className='cp-history-heading'>
                            Consumer Promotion History
                            </div>

                        <div className='cp-history-tables-cont'>

                            {
                                props.consumerPromotionHistory &&
                                props.consumerPromotionHistory?.map((item, ind) => (
                                    <table className='cp-history-table' key={'table' + ind}>
                                        <thead>
                                            <tr>
                                                <td colSpan='5' className='cp-table-header-1 cp-cell-border'>
                                                    {Object.keys(item)[0]}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className='cp-table-header-2 cp-cell-border' style={{ width: '60%' }}>Description</td>
                                                <td className='cp-table-header-2 cp-cell-border'>Week ST & ED</td>
                                                <td className='cp-table-header-2 cp-cell-border'>Category</td>
                                                <td className='cp-table-header-2 cp-cell-border'>Brand</td>
                                                <td className='cp-table-header-2 cp-cell-border'>MSKU</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Array.isArray(Object.values(item)) &&
                                                Object.values(item).map((elm) => (
                                                    elm.map((row, ind) => (
                                                        <tr key={'row' + ind}>
                                                            <td className='cp-cell-border'>{row.Description}</td>
                                                            <td className='cp-cell-border'>{row.StartWeek}-{row.EndWeek}</td>
                                                            <td className='cp-cell-border'>{row.categoryName}</td>
                                                            <td className='cp-cell-border'>{row.brandName}</td>
                                                            <td className='cp-cell-border'>{row.MASTER_SKU}</td>
                                                        </tr>
                                                    ))
                                                ))
                                            }

                                        </tbody>
                                    </table>
                                ))
                            }

                        </div>
                        {
                            props.consumerPromotionHistoryIsLoading
                                ?
                                <Loader flag={true} />
                                :
                                null
                        }
                    </div>

                </Fade>
            </Modal >
        </div >
    )
};

const mapStateToProps = state => {
    return {
        consumerPromotionHistory: state.ConsumerPromotionReducer.consumerPromotionHistory,
        consumerPromotionHistoryIsLoading: state.ConsumerPromotionReducer.consumerPromotionHistoryIsLoading,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getConsumerPromotionHistory: (
            selectedCategory,
            selectedBrand,
            selectedMasterSku
        ) => {
            return dispatch(ConsumerPromotionMiddleware.getConsumerPromotionHistory(
                selectedCategory,
                selectedBrand,
                selectedMasterSku
            ));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsumerPromotionHistory);
